export const tableColumnList = (ctx) => [
  {
    field: 'settlementDesc', // 1
    title: '结算说明',
    width: '120',
    editRender: {
      name: 'settlementDesc',
    },
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
    width: '120',
    editRender: {
      name: 'select',
      options: ctx.expenseType,
    },
  },
  {
    field: 'spaceAssetName',
    title: '空间资产',
    width: '180',
    editRender: {
      name: 'spaceAssetName',
      options: ctx.cotractSpaceList,
    },
  },
  {
    field: 'originalPrice',
    title: '原币结算单价(含税)',
    width: '150',
    editRender: { name: 'originalPrice' },
  },
  {
    field: 'settlementQuantity',
    title: '结算数量',
    width: '140',
    editRender: {
      name: 'settlementQuantity',
    },
  },
  {
    field: 'unitName',
    title: '计量单位',
    width: '140',
    editRender: {
      name: 'unitName',
    },
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    width: '150',
    editRender: {
      name: 'originalAmount',
    },
  },
  {
    field: 'currencyCode',
    title: '币种',
    width: '140',
    editRender: { name: 'currencyCode' },
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    width: '140',
    editRender: { name: 'exchangeRate' },
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额（含税）',
    width: '170',
    editRender: { name: 'domesticAmount' },
  },
  {
    field: 'additional',
    title: '附加',
    width: '140',
    editRender: { name: 'additional' },
  },

  {
    field: 'businessDocNo',
    title: '业务单据编号',
    width: '140',
    editRender: { name: 'businessDocNo' },
  },
  {
    field: 'remark',
    title: '备注',
    width: '140',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  // settlementDesc: [{ required: true, message: '必填字段' }],
  // originalAmount: [{ required: true, message: '必填字段' }],
  // domesticAmount: [{ required: true, message: '必填字段' }],
  expenseTypeName: [{ required: true, message: '必填字段' }],
  spaceAssetName: [{ required: true, message: '必填字段' }],
};
